import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ApsPermissionService } from '../../../services/aps-permission/aps-permission.service';

interface Contract {
  requestDate: Date;
  requestedDays: number;
  chassi: string;
  contractNumber: string;
  // Adicione outras propriedades do contrato aqui, se houver
}

@Component({
    selector: 'app-view-pending-cancellations',
    templateUrl: './view-pending-cancellations.component.html',
    styleUrls: ['./view-pending-cancellations.component.scss'],
    standalone: false
})
export class ViewPendingCancellationsComponent implements OnInit {

  cancellations: Contract[] = [];
  userWithPermission = false;

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translateService: TranslateService,
    private apsPermissionService: ApsPermissionService
  ) { }

  async ngOnInit(): Promise<void> {

    await this.apsPermissionService.bootstrapPermissions();

    this.userWithPermission = this.apsPermissionService.permissionValidation('TMAC:ScreenProcessContractCancel');

    if (!this.userWithPermission) {

      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('TRANSLATE.ERROR'),
        detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION')
      });

      setTimeout(() => {
        this.router.navigate(['/home']); 
      }, 500); 

      return; 
    }

  }

  processContract(contract: Contract): void {

    // Navegar para a tela de processamento, passando o número do contrato ou chassi como parâmetro
    this.router.navigate(['process-cancellation/', contract.contractNumber]);
  }

  private subtractDays(baseDate: Date, days: number): Date {
    const date = new Date(baseDate);
    date.setDate(date.getDate() - days);
    return date;
  }

}
